import { render, staticRenderFns } from "./TheSwitch.vue?vue&type=template&id=64ca4e29&scoped=true&"
import script from "./TheSwitch.vue?vue&type=script&lang=js&"
export * from "./TheSwitch.vue?vue&type=script&lang=js&"
import style0 from "./TheSwitch.vue?vue&type=style&index=0&id=64ca4e29&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ca4e29",
  null
  
)

export default component.exports